import {
    INTEGRATION_GET_SALES_CHANNEL_BEGIN,
    INTEGRATION_GET_SALES_CHANNEL_SUCCESS,
    INTEGRATION_GET_SALES_CHANNEL_FAILURE
} from '../constants'
import { BFFAgent } from 'BFFAgent'

export function getSalesChannel() {
    return async dispatch => {
        dispatch({
            type: INTEGRATION_GET_SALES_CHANNEL_BEGIN
        })

        try {
            const { data: { data } } = await BFFAgent.Integrations.getSalesChannel()
            
            dispatch({
                type: INTEGRATION_GET_SALES_CHANNEL_SUCCESS,
                data
            })
        } catch {
            dispatch({
                type: INTEGRATION_GET_SALES_CHANNEL_FAILURE
            })
        }
    }
}

export function reducer(state, action) {
    switch (action.type) {
        case INTEGRATION_GET_SALES_CHANNEL_BEGIN:
            return {
                ...state,
                salesChannelPending: true
            }

        case INTEGRATION_GET_SALES_CHANNEL_SUCCESS:
            return {
                ...state,
                salesChannel: action.data,
                salesChannelPending: false
            }

        case INTEGRATION_GET_SALES_CHANNEL_FAILURE:
            return {
                ...state,
                salesChannelPending: false
            }

        default:
            return state
    }
}
